import React from 'react';
import {_GPY,__GPYPost} from '../env.js'
import SelectLanguage from './SelectLanguage';
import GpyModalAlert from '../scoreboard/gametypes/lib/GpyModalAlert'
import RightLinks from '../RightLinks.js'

class LoginRegisterForm extends  React.Component  {

  constructor(props) {
   super(props);
   this.state = {
          email: "",
          _email: false,
          password : "",
          _password: false,
          password_valid : "",
          _password_valid: false,
          firstName : "",
          _firstName: false,
          lastName : "",
          _lastName: false,
          lang: _GPY.language,
          _dataConfirm : false,
          eventHandler: {},
        };
        this.modalClose = this.modalClose.bind(this);
        this.doChangeLang = this.doChangeLang.bind(this);
  }

  registerEvent(name,e) {
    var h = this.state.eventHandler
    h[name] = e;
    this.setState({eventHandler:h})
  }

  showModal(obj,t,b,cl){
   Object.keys(this.state.eventHandler).forEach(key => {
       var c = this.state.eventHandler[key];
       if(c !== undefined && c.showModal !== undefined){
         c.showModal(obj,t,b,cl);
       }
   });
 }

 modalClose() {
 }

 returnToLogin(){
   this.props.login.setCurrentForm("LoginForm");
 }


registerNewUser() {
      __GPYPost('storeNewUser',{
               email: this.state.email,
               password : this.state.password,
               firstName : this.state.firstName,
               lastName : this.state.lastName,
               lang: this.state.lang,
      },
      (r) => {
        var title = _GPY.i18n.get('user_messages_register_client_alert_title')
        var body = "";
        if(r.Result.state === 'SUCCESS') {
            body = r.Result.message;
            this.showModal(true,title,body, () => {
               this.returnToLogin();
            } );
        }
        if(r.Result.state === 'FAIL') {
            body = r.Result.message;
            if(r.Result.errorCode === 6003) {
              this.showModal(true,title,body, () => {
                 this.props.login.setCurrentForm("LoginLostPasswordForm");
              } );
            } else {
              this.showModal(true,title,body);
            }
        }
      },(fail) =>{

      });
  }

  isPasswordValid(e){
    return this.state.password === e;
  }

  onChange(name,validator,e) {
    console.log(name,validator,e);
      var s = this.state;
      s[name] = e.target.value;
      s["_" + name] = validator(s[name]);
      this.setState(s);
  }

  setCurrentForm(f) {
     this.props.login.setCurrentForm(f);
  }

  doChangeLang(e){
    console.log("locale->",e);
    this.setState({lang:e});
  }

  render () {
	   return (
         <div>
			     <div className="jumbotron">
           <div className="row">
              <div className="col"><h1 className="display-4">{_GPY.i18n.get('login_form_headLine')}</h1></div>
              <div className="col text-right"><img style={{maxWidth : '200px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid mx-auto" alt="Guppyi Logo"/></div>
           </div>
				  <p className="lead">{_GPY.i18n.get('regsiter_form_subHeadLine')}</p>
				  <hr className="my-4"/>


            <div className="row">
               <div className="col">
                <div className="form-group">
						        <label htmlFor="register_email">{_GPY.i18n.get('register_form_input_email_title')}</label>
				 		   	    <input name="register_email" onChange={this.onChange.bind(this,"email",_GPY.isValidEmail)} type="email" value={this.state.email}  className={!this.state._email&&this.state.email!==''?"form-control border border-danger":"form-control"} aria-describedby="emailHelp" placeholder={_GPY.i18n.get('register_form_input_email_placeholder')}/>
                    {!this.state._email&&this.state.email!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_email')}</small>:""}
				 			  </div>
              </div>
                <div className="col">
                  <div className="form-group">
                      <label htmlFor="regsiter_Language">{_GPY.i18n.get('register_form_input_language_title')}</label>
                      <SelectLanguage doChange={this.doChangeLang.bind(this)}/>
                  </div>
                </div>
             </div>

              <div className="row">
                 <div className="col">
  						 	    <div className="form-group">
  				  			    <label htmlFor="register_password">{_GPY.i18n.get('register_form_input_password_title')}</label>
  				  			    <input  name="register_password"  onChange={this.onChange.bind(this,"password",_GPY.isValidPassword)}  value={this.state.password} type="password" className={!this.state._password&&this.state.password!==''?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('register_form_input_password_placeholder')}/>
                      {!this.state._password&&this.state.password!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_password')}</small>:""}
  				  		    </div>
                </div>
                <div className="col">
				  		    <div className="form-group">
				  		       <label htmlFor="register_password_valid">{_GPY.i18n.get('register_form_input_password_repeat_title')}</label>
				  		       <input  name="register_password_valid" onChange={this.onChange.bind(this,"password_valid",this.isPasswordValid.bind(this))}  value={this.state.password_valid} className={!this.state._password_valid&&this.state.password_valid!==''?"form-control border border-danger":"form-control"} type="password" placeholder={_GPY.i18n.get('register_form_input_password_repeat_placeholder')}/>
                     {!this.state._password_valid&&this.state.password_valid!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_password_repeat')}</small>:""}
				  		      </div>
                  </div>
                </div>

                  <div className="row">
                       <div className="col">
        				  		    <div className="form-group">
        				  		       <label htmlFor="regsiter_firstName">{_GPY.i18n.get('register_form_input_firstName_title')}</label>
        				  		       <input name="regsiter_firstName" onChange={this.onChange.bind(this,"firstName",_GPY.isMin2)}  value={this.state.firstName} type="text" className={!this.state._firstName&&this.state.firstName!==''?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('register_form_input_firstName_placeholder')}/>
                             {!this.state._firstName&&this.state.firstName!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
        				  		    </div>
                        </div>
                        <div className="col">
        				  		     <div className="form-group">
        				  		       <label htmlFor="regsiter_lastName">{_GPY.i18n.get('register_form_input_lastName_title')}</label>
        				  		       <input name="regsiter_lastName" onChange={this.onChange.bind(this,"lastName",_GPY.isMin2)}  value={this.state.lastName} type="text" className={!this.state._lastName&&this.state.lastName!==''?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('register_form_input_lastName_placeholder')}/>
                             {!this.state._lastName&&this.state.lastName!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_more_then_2_chars')}</small>:""}
        				  		    </div>
                      </div>
                  </div>

              <div className="row">
                   <div className="col">
                   <div className="form-group form-check">
                      <input type="checkbox" onChange={ ()=>this.setState({_dataConfirm:!this.state._dataConfirm}) } checked={this.state._dataConfirm} className="form-check-input" id="register_from_agb_data_protection_read"/>
                      <label className="form-check-label" htmlFor="register_from_agb_data_protection_read">
                      {_GPY.i18n.get('register_from_agb_data_protection_confirm')}
                      </label>
                      <p><RightLinks/></p>
                    </div>
                 </div>
              </div>

				 		 <div className="row">
				 		  <div className="col">
                  <button onClick={this.returnToLogin.bind(this)} className="btn btn-light btn-lg" >{_GPY.i18n.get('register_form_button_login')}</button>
		 		 	    </div>
		 		 	    <div className="col">
		 		 		      <div className="float-right">
                  {this.state._dataConfirm && this.state._email && this.state._password && this.state._password_valid && this.state._firstName && this.state._lastName?
                    <button onClick={this.registerNewUser.bind(this)} className="btn btn-success btn-lg">{_GPY.i18n.get('register_form_button_register')}</button>
                    :
                    <button className="btn btn-primary btn-lg disabled">{_GPY.i18n.get('register_form_button_register')}</button>
                  }

		 		 		      </div>
		 		 	    </div>
				 	  </div>
          </div>
         <GpyModalAlert parent={this} icon="check" text="body" close={this.modalClose}/>
				</div>
	  	)
  }
}
export default LoginRegisterForm;
